export function getYouTubeVideoId(inputUrl) {
  if (!inputUrl) return '';
  try {
    const url = new URL(inputUrl);
    const host = url.hostname.replace(/^www\./, '');

    if (host === 'youtu.be') {
      return url.pathname.split('/').filter(Boolean)[0] || '';
    }

    if (host === 'youtube.com' || host === 'm.youtube.com') {
      if (url.pathname === '/watch') return url.searchParams.get('v') || '';
      if (url.pathname.startsWith('/shorts/')) return url.pathname.split('/')[2] || '';
      if (url.pathname.startsWith('/embed/')) return url.pathname.split('/')[2] || '';
      if (url.pathname.startsWith('/live/')) return url.pathname.split('/')[2] || '';
    }

    return '';
  } catch {
    return '';
  }
}

export function getYouTubeEmbedUrl(inputUrl) {
  const videoId = getYouTubeVideoId(inputUrl);
  return videoId ? `https://www.youtube.com/embed/${videoId}` : '';
}
